import React, { useState, useEffect } from "react";
import {
  DataGrid,
  GridToolbarContainer,
  GridFilterToolbarButton,
} from "@material-ui/data-grid";
import {
  Typography,
  Button,
  Tooltip,
  IconButton,
  makeStyles,
  TextField,
  Grid,
} from "@material-ui/core";
import ShowAlert from "../../components/ShowAlert";
import IncapacitiesBottomNavigation from "../../components/staff/IncapacitiesBottomNavigation";
import DateFnsUtils from "@date-io/date-fns";
import teal from "@material-ui/core/colors/teal";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import CancelIcon from "@material-ui/icons/Cancel";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import DateRangeIcon from "@material-ui/icons/DateRange";
import SearchIcon from "@material-ui/icons/Search";
import red from "@material-ui/core/colors/red";
// redux
import { connect } from "react-redux";
import renderCellExpand from "../../components/renderCellExpand";
import useBrowserContextCommunication from "react-window-communication-hook";
// Services
import { staffAppointmentService } from "../../services/staff/staffAppointmentService";
import { appointmentService } from "../../services/appointmentService";
//Mapeo de clinicas
import { clinicsM } from "../../services/clinicsM";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  heroContent: {
    backgroundImage: `url(https://ecodigital.portubien.co/citapp_user/resources/recursos/img/teleconsultas.jpg)`,
    //backgroundImage: `url(${Background})`,
    backgroundPosition: "center 0%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    padding: theme.spacing(2, 0, 0),
    paddingBottom: "20px",
    //borderRadius: '0px!important',
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  field: {
    width: "100%",
  },
  paper: {
    width: "90%",
    height: "100%",
    marginTop: "10px",
    paddingTop: "10px",
    paddingBottom: "10px",
    paddingRight: "20px",
    marginBottom: "20px",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    width: 160,
  },
}));

const clinicsMaping = clinicsM.Maping();

const StaffMedicalOrders = (props) => {
  const classes = useStyles();
  const [title, setTitle] = useState("Ordenamientos Médicos");
  const [defectColor, setDefectColor] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    new Date(new Date() - 1000 * 60 * 60 * 24)
  );
  const [rowsLoading, setRowsLoading] = useState(false);
  const [rows, setRows] = useState([]);

  const [communicationState, postMessage] = useBrowserContextCommunication(
    "DashboardStaffChanel"
  );

  const [clinicalHistory, setClinicalHistory] = useState("");
  const [formulaMedica, setFormulaMedica] = useState("");
  const [incapacidad, setIncapacidad] = useState("");
  const [ordenes, setOrdenes] = useState("");
  const [rowsInitial, setRowsInitial] = useState([]);
  const clinicaEs14 = props.clinic?.cli_id === 14;

  const columnsIncapacities = [
    {
      field: "sede",
      headerName: "Sede",
      width: 115,
      renderCell: (params) => (
        <div>
          {clinicaEs14 && params.row.sede === "001"
            ? "Itagüí"
            : clinicaEs14 && params.row.sede === "002"
            ? "Bello"
            : params.row.sede}
        </div>
      ),
      hide: !clinicaEs14,
    },
    {
      field: "CitNum",
      headerName: "Cita",
      width: 85,
      renderCell: (params) => (
        <div>
          {params.row.gestionar === true ? (
            <strong>
              <div style={{ color: teal[500] }}>{params.row.CitNum}</div>
            </strong>
          ) : (
            <div>{params.row.CitNum}</div>
          )}
        </div>
      ),
    },
    {
      field: "CitCed",
      headerName: "Cedula",
      width: 120,
      renderCell: (params) => (
        <div>
          {params.row.gestionar === true ? (
            <strong>
              <div style={{ color: teal[500] }}>{params.row.CitCed}</div>
            </strong>
          ) : (
            <div>{params.row.CitCed}</div>
          )}
        </div>
      ),
    },
    {
      field: "CitFecPa",
      headerName: "Fecha",
      width: 100,
      renderCell: (params) => (
        <div>
          {params.row.gestionar === true ? (
            <strong>
              <div style={{ color: teal[500] }}>{params.row.CitFecPa}</div>
            </strong>
          ) : (
            <div>{params.row.CitFecPa}</div>
          )}
        </div>
      ),
    },
    {
      field: "CitHorI",
      headerName: "Hora",
      width: 90,
      renderCell: (params) => (
        <div>
          {params.row.gestionar === true ? (
            <strong>
              <div style={{ color: teal[500] }}>{params.row.CitHorI}</div>
            </strong>
          ) : (
            <div>{params.row.CitHorI}</div>
          )}
        </div>
      ),
    },
    {
      field: "MENomE",
      headerName: "Diagnóstico",
      width: 130,
      renderCell: (params) => (
        <div>
          {params.row.gestionar === true ? (
            <strong>
              <div style={{ color: teal[500] }}>{params.row.MENomE}</div>
            </strong>
          ) : (
            <div>{params.row.MENomE}</div>
          )}
        </div>
      ),
    },
    {
      field: "CitNomPr",
      headerName: "Procedimiento",
      width: 200,
      renderCell: (params) => (
        <div>
          {params.row.gestionar === true ? (
            <strong>
              <div style={{ color: teal[500] }}>{params.row.CitNomPr}</div>
            </strong>
          ) : (
            <div>{params.row.CitNomPr}</div>
          )}
        </div>
      ),
    },
    {
      field: "CITPAC",
      headerName: "Paciente",
      width: 110,
      renderCell: (params) => (
        <div>
          {params.row.gestionar === true ? (
            <strong>
              <div style={{ color: teal[500] }}>{params.row.CITPAC}</div>
            </strong>
          ) : (
            <div>{params.row.CITPAC}</div>
          )}
        </div>
      ),
    },
    {
      field: "medico",
      headerName: "Médico",
      width: 300,
      renderCell: (params) => (
        <div>
          {params.row.gestionar === true ? (
            <strong>
              <div style={{ color: teal[500] }}>{params.row.medico}</div>
            </strong>
          ) : (
            <div>{params.row.medico}</div>
          )}
        </div>
      ),
    },
    {
      field: "estado",
      headerName: "Estado",
      width: 110,
      renderCell: (params) => (
        <div>
          {params.row.gestionar === true ? (
            <strong>
              <div style={{ color: teal[500] }}>{params.row.estado}</div>
            </strong>
          ) : (
            <div>{params.row.estado}</div>
          )}
        </div>
      ),
    },
    {
      field: "Aprobar",
      headerName: "Formular Gestión",
      width: 180,
      renderCell: (params) => (
        <IconButton
          disabled={title === "Histórico de incapacidades radicadas"}
          onClick={() => handleFormularOrdenamiento(params)}
        >
          {title === "Histórico de incapacidades radicadas" ? (
            ""
          ) : (
            <CheckCircleIcon color="primary" />
          )}
        </IconButton>
      ),
    },
    /* {
      field: 'Cancelar',
      headerName: 'Cancelar',
      width: 100,
      renderCell: (params) => (
        <IconButton
          //onClick={() => handleCancelAppoinments(params)}
        >
          <CancelIcon style={{ color: red[700] }} />
        </IconButton>
      ),
    }, */
  ];

  function CustomToolbar() {
    return (
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
          className={classes.textField}
        >
          <Grid>
            <Typography
              variant="subtitle2"
              color={defectColor ? "primary" : "error"}
              gutterBottom
            >
              Buscar por fecha
            </Typography>
          </Grid>
          <Grid>
            <KeyboardDatePicker
              variant="dialog"
              disabled={title === "Histórico de incapacidades radicadas"}
              margin="dense"
              inputVariant="standard"
              id="date-picker-dialog"
              showTodayButton={true}
              format="dd/MM/yyyy"
              value={selectedDate}
              InputProps={{
                disableUnderline: true,
                disabled: true,
              }}
              InputAdornmentProps={{ position: "start" }}
              onChange={handleDateChange}
            />
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    );
  }

  useEffect(async () => {
    await getAllAtendidaAppointments(selectedDate);
  }, []);

  useEffect(async () => {
    if (communicationState.lastMessage) {
      const { reloadOrdenes } = communicationState.lastMessage;
      if (reloadOrdenes) {
        await getAllAtendidaAppointments(selectedDate);
      }
    }
  }, [communicationState]);

  const getAllAtendidaAppointments = async () => {
    //Get data
    setRowsLoading(true);
    const resp = await staffAppointmentService.getAllAtendidaAppointments(
      props.clinic
    );
    // parse data
    //console.log("desde resp ", resp);

    //console.log("user ", props.user?.id);
    const rowsToRender = resp.data.map((row, index) => {
      //const appointmentInfo = row.appointment_info_from_citapp;
      return {
        ...row,
        id: index,
      };
    });
    //console.log("PRINT DATA FROM PYTHON", rowsToRender);
    setRows(rowsToRender);
    setRowsInitial(rowsToRender);
    setRowsLoading(false);
  };

  const handleGetDocumentsAppointments = async (
    clinic_id,
    card_id,
    cita_num
  ) => {
    const resp = await appointmentService.getDocumentsAppointments(
      clinic_id,
      card_id,
      cita_num
    );
    console.log("respuesta", resp);

    if (resp.HC) {
      setClinicalHistory(resp.HC);
    }
    if (resp.Incapacidad) {
      setIncapacidad(resp.Incapacidad);
    }
    if (resp.Ordenes) {
      setOrdenes(resp.Ordenes);
    }
    if (resp.Formula_Medica) {
      setFormulaMedica(resp.Formula_Medica);
    }
  };

  const handleDateChange = async (date) => {
    setSelectedDate(date);
    setDefectColor(true);
    await getAllIncapacitiesByDate(date);
    //setTimeout(() => console.log("valor nuevo"), 4000);
  };

  const getAllIncapacitiesByDate = async (selected_date) => {
    //Get data
    setRowsLoading(true);
    const resp = await staffAppointmentService.getAllIncapacitiesByDate(
      selected_date.toISOString(),
      props.clinic
    );
    // parse data
    console.log("desde resp ", resp);
    const rowsToRender = resp.data.map((row, index) => {
      //const appointmentInfo = row.appointment_info_from_citapp;
      return {
        ...row,
        id: index,
      };
    });
    console.log("PRINT DATA FROM PYTHON", rowsToRender);
    setRows(rowsToRender);
    setRowsInitial(rowsToRender);
    setRowsLoading(false);
  };

  const handleFormularOrdenamiento = (params) => {
    props.handleOpenCloseMedicalOrdersModal(params.row);
    //console.log("params row ", params.row);
    //changeIncapacityStatus(params.row, "Radicado por EPS");
  };

  const changeIncapacityStatus = async (row, new_status) => {
    //Get data
    setRowsLoading(true);
    const resp = await staffAppointmentService.changeIncapacityStatus(
      props.clinic,
      row,
      new_status
    );

    await getAllIncapacitiesByDate(selectedDate);
    setRowsLoading(false);
  };

  const getAllHistorycIncapacities = async () => {
    setRowsLoading(true);
    const allHistorycIncapacities =
      await staffAppointmentService.getAllHistorycIncapacities(props.clinic);
    setRows(allHistorycIncapacities.data);
    setRowsLoading(false);
  };

  const handleSwitchChange = async (selected) => {
    if (selected === "toRadic") {
      setTitle("Incapacidades por radicar");
      // set new rows data
      //setRows(rowser);
      await getAllIncapacitiesByDate(selectedDate);
    } else {
      setTitle("Histórico de incapacidades radicadas");
      // set new rows data
      getAllHistorycIncapacities();
      //setRows(priorityAppoint);
    }
  };

  /* useEffect(async () => {
    if (communicationState.lastMessage){
      const { reloadIncapacities } = communicationState.lastMessage
      if (reloadIncapacities){
        await getAllIncapacitiesByDate(selectedDate);
      }
    }
  }, [communicationState]) */

  const handleSearchChange = (e) => {
    if (e.target.value !== "") {
      setRows((rowsInitial) =>
        rowsInitial.filter((row) =>
          Object.values(row).some(
            (value) =>
              typeof value === "string" &&
              value.toLowerCase().includes(e.target.value.toLowerCase())
          )
        )
      );
    } else {
      setRows(rowsInitial);
    }
  };

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      {alert.show && <ShowAlert {...alert} />}
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <div>
          <input
            type="text"
            placeholder="Buscar..."
            className="search"
            onChange={handleSearchChange}
            style={{ fontSize: "17px", paddingRight: "5px" }}
          ></input>
        </div>
      </div>
      <DataGrid
        autoHeight
        /* components={{
          Toolbar: CustomToolbar
        }} */
        rows={rows}
        loading={rowsLoading}
        columns={columnsIncapacities}
        pageSize={15}
      />
      {/* <IncapacitiesBottomNavigation
       handleSwitchChange={handleSwitchChange}
      /> */}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  user: state.user,
  lastContrat: state.lastContrat,
  clinic: state.clinic,
});

export default connect(mapStateToProps, null)(StaffMedicalOrders);
